import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import './Settings.css';

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
    },
});

function displayString(x) {
    if (x !== undefined) {
        return x;
    } else {
        return <span className="nullItem">null</span>;
    }
}

function displayBoolean(x) {
    if (x !== undefined) {
        if (x) {
            return 'true';
        } else {
            return 'false';
        }
    } else {
        return <span className="nullItem">null</span>;
    }
}

function displayProperty(title, rawValue) {
    var value = '';

    switch (typeof rawValue) {
        case 'string':
            value = displayString(rawValue);
            break;
        case 'boolean':
            value = displayBoolean(rawValue);
            break;
        case 'number':
            value = displayString(rawValue);
            break;
        case 'undefined':
            value = displayString(rawValue);
            break;
        default:
            console.log(typeof rawValue);
            value = 'XXX';
    }

    return (
        <div className="vsDialogData__itemContainer">
            <div className="vsDialogData__itemLabel">{title}</div>
            <div className="vsDialogData__itemValue">{value}</div>
        </div>
    );
}

function SettingsApp(props) {

    const classes = useStyles();

    useEffect(() => {
        if (props) {
            console.log('props', props);
        }
    });

    return (
        <Paper className={classes.root}>

            <div className="setDialogData">
                <div className="setDialogData__middle">
                    {displayProperty('Name', props.data.config.name)}
                    {displayProperty('Version', props.data.config.version)}
                    {displayProperty('Logo', props.data.config.logo)}
                    {displayProperty('Analytics', props.data.config.analytics)}
                    {displayProperty('Tag System', props.data.config.tagSystem)}
                    {displayProperty('Server Url', props.data.config.servers[0].url)}
                </div>

            </div>
        </Paper>
    )
}

export default SettingsApp
